// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".price-item .price-item-checkbox .el-checkbox-group .el-checkbox .el-checkbox__label{display:none}.limit-item .el-radio .el-radio__label{font-size:12px}", ""]);
// Exports
module.exports = exports;
